/**
 * BudgetHealthStatusService
 * Service for BudgetHealthStatus lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetHealthStatus CRUD operations */
export class BudgetHealthStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetHealthStatusService.DEFAULT_SERVICE_PATH,
            basePath: BudgetHealthStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetHealthStatusService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetHealthStatusService.BASE_PATH = 'api/budgethealthstatuses';
//# sourceMappingURL=BudgetHealthStatusService.js.map